import {useState, useEffect} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";
import {S14View} from "./S14View";

// С14 (Ш4) — изчертани площи по масиви, текуща срещу предходна стопанска
// година. Обхватът е землище ИЛИ община (същият избор като С6), ползвателят е
// задължителен. Щ6: таблиците живеят в S14View — същите ги показва и публичният
// линк.
export const ReportS14 = () => {
    const {year, scopeType, scope} = useParams();
    const [searchParams] = useSearchParams();
    const bullstat = searchParams.get('bullstat');
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const request = requester();

    const query = `${scopeType}=${encodeURIComponent(scope)}`
        + (bullstat ? `&bullstat=${encodeURIComponent(bullstat)}` : '');

    useEffect(() => {
        setLoading(true);
        setError('');
        request.get(`${baseUrl()}/reports/s14/${year}?${query}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message || 'Справката не се зареди.');
                setLoading(false);
            });
    }, [year, scopeType, scope, bullstat]);

    const handlePdf = () => {
        downloadPdf(`/reports/s14/${year}?${query}&format=pdf`, `S14_${scope}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (error) return <div className="mt-3 alert alert-warning">{error}</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const c = data.company;
    const scopeLabel = data.scope.type === "settlement"
        ? `Землище: ${data.scope.name}`
        : `Община: ${data.scope.name}`;

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>
                        С14 — Изчертани площи, текуща и предходна година
                    </h5>
                    <div>{c.company_name}, Булстат: {c.bullstat}</div>
                    <div>{scopeLabel}</div>
                    <div>Стопанска {data.previous_year} срещу {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}
                        disabled={data.sections.length === 0}>PDF</button>
            </div>

            <S14View data={data}/>
        </div>
    );
};
